import React, { useState } from 'react';
import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core';
import { CustomizedButton } from '@components/Customized';

const useStyles = makeStyles((theme) => ({
  dialogStyle: {
    zIndex: 9999
  },
  paper: {
    margin: '12px'
  },
  title: {
    fontWeight: 500,
    paddingBottom: '4px',
    '& .MuiTypography-root': {
      wordBreak: 'keep-all'
    }
  },
  description: {
    fontSize: '14px',
    fontWeight: 'normal',
    wordBreak: 'keep-all'
  },
  actions: {
    padding: '8px'
  },
  cancelButton: {
    color: theme.palette.text.secondary
  }
}));

interface Props {
  isOpen: boolean;
  title: string | React.ReactNode;
  description?: string;
  onOk: () => void;
  okText?: string;
  onClose?: () => void;
  onCancle?: () => void;
  closeText?: string;
}

const ConfirmPresenter: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [disabledOk, setDisabledOk] = useState(false);
  const onOk = () => {
    setDisabledOk(true);
    props.onOk();
  };
  return (
    <Dialog
      className={classes.dialogStyle}
      onClose={props.onClose}
      open={props.isOpen}
      classes={{ paper: classes.paper }}
    >
      <DialogTitle classes={{ root: classes.title }}>{props.title}</DialogTitle>

      <DialogContent>
        {props.description && (
          <DialogContentText classes={{ root: classes.description }}>
            {props.description}
          </DialogContentText>
        )}
        {props.children}
      </DialogContent>

      <DialogActions classes={{ root: classes.actions }}>
        {props.onClose && (
          <CustomizedButton
            color="default"
            onClick={props.onCancle ? props.onCancle : props.onClose}
            classes={{ root: classes.cancelButton }}
          >
            {props.closeText ? props.closeText : '취소'}
          </CustomizedButton>
        )}
        <CustomizedButton color="primary" onClick={onOk} disabled={disabledOk}>
          {props.okText ? props.okText : '확인'}
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmPresenter;
